import { type UiStore, useUi } from './ui/store';

/** The box-select rectangle while it is being dragged (subscribes alone, so the match screen doesn't re-render). */
export function Marquee({ ui }: { ui: UiStore }) {
  const r = useUi(ui, (s) => s.marquee);
  if (!r) return null;
  return (
    <div
      className="pointer-events-none fixed z-20 border border-accent bg-accent/15"
      style={{ left: r.left, top: r.top, width: r.right - r.left, height: r.bottom - r.top }}
    />
  );
}
